import { call, put, takeLatest } from "redux-saga/effects";
import { studioConstants } from "../actions/constants/studioConstants";
import { studioService } from "../services/studioService";
import { commonActions } from "../actions/commonAction";
import { commonConstants } from "@/actions/constants/commonConstants";

function* listStudios(action: any): any {
    try {
        const response = yield call(studioService.listStudios, action.payload);
        if (response.success) {
            yield put({ type: studioConstants.listStudiosSuccess, payload: response.resultObject });
        } else {
            yield put({
                type: studioConstants.listStudiosFailure,
                payload: response.message || response.errorMessage,
            });

            yield put(commonActions.errorResponse(response.message || "Failed to fetch studios"));
        }
    } catch (error) {
        yield put({ type: studioConstants.listStudiosFailure, payload: error });
    }
}

function* viewStudio(action: any): any {
    try {
        const response = yield call(studioService.viewStudio, action.payload);
        if (response.success) {
            yield put({ type: studioConstants.viewStudioSuccess, payload: response.resultObject });
        } else {
            yield put({
                type: studioConstants.viewStudioFailure,
                payload: response.message || response.errorMessage,
            });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.message || response.errorMessage,
            });
        }
    } catch (error) {
        yield put({ type: studioConstants.viewStudioFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}
function* updateStudio(action: any): any {
    try {
        const response = yield call(studioService.updateStudio, action.payload);
        if (response.success) {
            yield put({ type: studioConstants.updateStudioSuccess, payload: response.resultObject });
            yield put({
                type: commonConstants.showSuccessMessage,
                payload: response.message || response.errorMessage,
            })
        } else {
            yield put({
                type: studioConstants.updateStudioFailure,
                payload: response.message || response.errorMessage,
            });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.message || response.errorMessage,
            });
        }
    } catch (error) {
        yield put({ type: studioConstants.updateStudioFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}
function* getStudioCity(): any {
    try {
        const response = yield call(studioService.getStudioCity);
        if (response.success) {
            yield put({ type: studioConstants.getStudioCitySuccess, payload: response.resultObject });
        } else {
            yield put({ type: studioConstants.getStudioCityFailure, payload: response.message });
        }
    } catch (error) {
        yield put({ type: studioConstants.getStudioCityFailure, payload: error });
    }
}

function* deactivateStudio(action: any): any {
    try {
        const response = yield call(studioService.toggleStudioStatus, { 
            id: action.payload.id, 
            action: 'deactivate', 
            reason: action.payload.reason 
        });
        if (response.success) {
            yield put({ type: studioConstants.deactivateStudioSuccess, payload: response.resultObject });
            yield put({
                type: commonConstants.showSuccessMessage,
                payload: response.message || "Studio deactivated successfully",
            });
        } else {
            yield put({
                type: studioConstants.deactivateStudioFailure,
                payload: response.message || response.errorMessage,
            });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.errorMessage || response.message || "Failed to deactivate studio",
            });
        }
    } catch (error) {
        yield put({ type: studioConstants.deactivateStudioFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}

function* reactivateStudio(action: any): any {
    try {
        const response = yield call(studioService.toggleStudioStatus, { 
            id: action.payload, 
            action: 'reactivate' 
        });
        if (response.success) {
            yield put({ type: studioConstants.reactivateStudioSuccess, payload: response.resultObject });
            yield put({
                type: commonConstants.showSuccessMessage,
                payload: response.message || "Studio reactivated successfully",
            });
        } else {
            yield put({
                type: studioConstants.reactivateStudioFailure,
                payload: response.message || response.errorMessage,
            });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.errorMessage || response.message || "Failed to reactivate studio",
            });
        }
    } catch (error) {
        yield put({ type: studioConstants.reactivateStudioFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}

export const studioSaga = {
    listStudios,
    viewStudio,
    updateStudio,
    getStudioCity,
    deactivateStudio,
    reactivateStudio,
};
